export class PROCESS {
  public static ENV: any = {};
  public static infra = 'local';

  public static _isProd = false;

  public static load() {
    PROCESS.infra = process.env.REACT_APP_INFRA || 'local';

    // let _PROD = false;
    // if (process.env.INFRA && process.env.INFRA.indexOf('local') >= 0) {
    //   process_env = JSON.parse(JSON.stringify(env.dev));
    //   _PROD = false;
    // } else if (process.env.INFRA && process.env.INFRA.indexOf('dev') >= 0) {
    //   process_env = JSON.parse(JSON.stringify(env.dev));
    //   _PROD = false;
    // } else if (process.env.INFRA && process.env.INFRA.indexOf('prod') >= 0) {
    //   process_env = JSON.parse(JSON.stringify(env.prod));
    //   _PROD = true;
    // }

    PROCESS._isProd = process.env.REACT_APP_INFRA === 'prod';
    PROCESS.ENV.API = process.env.REACT_APP_API;
    PROCESS.ENV.S1ACCOUNT = process.env.REACT_APP_S1ACCOUNT;

    //PROCESS.ENV.API = 'https://devaddsvc.huenhome.kr:8888';
  }

  public static get isProd() {
    return PROCESS._isProd;
  }
  public static get isLocal() {
    return PROCESS.infra === 'local';
  }

  public static get isDev() {
    return PROCESS.infra === 'dev';
  }

}

PROCESS.load();
